export default function getSortObjForCol(col) {
    // If the column name is prefixed with a_ or d_ sort in the corresponding direction
    if (col[1] === '_') {
        const id = col.substring(2);
        const desc = col[0] === 'd' ? true : false;
        return { id, desc };
    }

    const ascendingSortColumns = [
        'goalieFullName',
        'skaterFullName',
        'franchiseName',
        'teamFullName',
        'goalsAgainstAverage',
    ];
    if (ascendingSortColumns.includes(col)) {
        return { id: col, desc: false };
    }
    return { id: col, desc: true };
}
